import React,{useState,useEffect} from 'react';
import { addStrategyFace } from '../../Interfaces/Interfaces';
import { Grid,Box,Typography,Button, FormControl} from '@mui/material';
import { Formik,Form } from 'formik';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import { addStrategySchema } from '../../StaticData/index';
import {CircularProgress} from '@mui/material';
import {useEditStrategy } from '../../Hooks';
import { useSelector } from 'react-redux';
import moment from "jalali-moment";
import { DatePicker } from '@mui/x-date-pickers';


const EditStrategy = (props:any) => {
  const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
  // const userId:string=useSelector((state:any)=>state.loign.userInfo.userId);
  let{personId,onClose,setShowToastMessage,setAddStaffState,periodId,afterSuccess}=props;
    
    // const editSuccess=()=>{
    //     onClose()
    // }
   
    const{mutate:callEditPersonStaff,data:editUserData,isSuccess:editUserSuccess,isLoading:editPersonLoading}=useEditStrategy()
    const[editPersonInitialValues,setEditPersonInitialValues]=useState<any>();
    const[successAddUser,setSuccessAddUser]=useState<Boolean>(false);
    const[addUserMesaage,setAddUserMessage]=useState<string>('');
    const [frommeetingjLRealDate, setfromMeetingjLRealDate] = useState<any>("");
    const [tomeetingLRealDate, settoMeetingjLRealDate] = useState<any>("");
    const [toLRealDate, setToLRealDate] = useState<Date | null>(null);
    const [fromLRealDate, setFromLRealDate] = useState<any>("");

    useEffect(() => {
      if (personId) {
        let {
          realFromDate,
          realToDate,
          description,
          id,
          meetingDate,
          tenantId,
          name,
        } = personId;
  
        let initVal = {
          description: description,
          id: id,
          meetingDate,
          tenantId,
          name: name,
          teamIds: [],
        };
        setEditPersonInitialValues(initVal);
  
        if (realFromDate !== null) {
          setFromLRealDate(new Date(realFromDate));
        }

        if (realToDate !== null) {
          setToLRealDate(new Date(realToDate));
        }
        if (realToDate !== null && !isNaN(Date.parse(realToDate))) {
          setToLRealDate(new Date(realToDate));
        }
        
        
      }else if(periodId){
        let {
          realFromDate,
          realToDate,
          description,
          idd,
          meetingDate,
          tenantId,
          name,
        } = periodId;
  
        let initVal = {
          description: description,
          id: idd,
          meetingDate,
          tenantId,
          name: name,
          teamIds: [],
        };
        setEditPersonInitialValues(initVal);
  
        if (realFromDate !== null) {
          setFromLRealDate(new Date(realFromDate));
        }

        if (realToDate !== null) {
          setToLRealDate(new Date(realToDate));
        }
      }
    }, [personId]);    
     
const handleClose=()=>{
    onClose(false)
}

// useEffect(() => {
//   if (fromLRealDate !== "") {
//     setfromMeetingjLRealDate(moment(fromLRealDate).format("jYYYY/jM/jD"));
//   }
// }, [fromLRealDate]);
useEffect(() => {
  if (fromLRealDate instanceof Date && !isNaN(fromLRealDate.getTime())) {
    setfromMeetingjLRealDate(moment(fromLRealDate).format("jYYYY/jM/jD"));
  }
}, [fromLRealDate]);


// useEffect(() => {
//   if (toLRealDate !== "") {
//     settoMeetingjLRealDate(moment(toLRealDate).format("jYYYY/jM/jD"));
//   }
// }, [toLRealDate]);
useEffect(() => {
  if (toLRealDate instanceof Date && !isNaN(toLRealDate.getTime())) {
    settoMeetingjLRealDate(moment(toLRealDate).format("jYYYY/jM/jD"));
  }
}, [toLRealDate]);


const initialUpdateMeeting = (data: any) => {
  data.tenantId = tenantId;
  data.fromDate = frommeetingjLRealDate;
  data.toDate = tomeetingLRealDate;
  callEditPersonStaff(data);
};


const initialSubmitForm=(data:any)=>{
  initialUpdateMeeting(data);
}

useEffect(() => {

  if (editUserData) {
    setShowToastMessage(true);
    setAddStaffState(editUserData?.data)

    if(editUserData?.data?.isSuccess){
      handleClose();
      afterSuccess();
    }
  } 
}, [editUserData,editUserSuccess])



  return (
    <Grid container>
    <Grid  item xs={12}  >
    <Box width={'100%'} textAlign={'center'}   >
    </Box>
    </Grid>
 
 
    <Grid item xs={12}   >
    {
     !successAddUser?<Formik enableReinitialize
     validationSchema={addStrategySchema}
     initialValues={editPersonInitialValues}
     onSubmit={(data:any) => {
       initialSubmitForm(data)
 
     }}
   >
     {
       ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
         <Form>
           <Grid container columnSpacing={1} sx={{bgcolor: 'background.paper',mx:'auto',borderRadius:3}}   >
           <Grid item xs={12} md={12}  >
            <div className='error'>
            </div>
              <FormikControl
                control='textField'
                type='text'
                label='نام'
                name='name'
                fullWidth
                value={values?.name||''}
                ErrorMessage="name" 
              />
            </Grid>

            <Grid item xs={12}  >
            <div className='error'>
            </div>
              <FormikControl
                control='textField'
                type='text'
                label='توضیحات'
                name='description'
                fullWidth
                value={values?.description ||''}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl sx={{ p: "8px" }} fullWidth>
                {/* <DatePicker
                  slotProps={{ textField: { size: "small" } }}
                  label={"از تاریخ"}
                  value={fromLRealDate || ""}
                  onChange={(newValue: any) => {
                    setFromLRealDate(newValue);
                  }}
                /> */}
                <DatePicker
  slotProps={{
    textField: {
      size: "small",
      onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Delete" || event.key === "Backspace") {
          setFromLRealDate(null);
        }
      },
    },
  }}
  label={"از تاریخ"}
  value={fromLRealDate || null}
  onChange={(newValue: any) => {
    setFromLRealDate(newValue || null);
  }}
/>

              </FormControl>
            </Grid>

              <Grid item xs={12} md={6}>
                <FormControl sx={{ p: "8px" }} fullWidth>
                  {/* <DatePicker
                    slotProps={{ textField: { size: "small" } }}
                    label={"تا تاریخ"}
                    value={toLRealDate || ""}
                    onChange={(newValue: any) => {
                      setToLRealDate(newValue);
                    }}
                  /> */}
                  <DatePicker
  slotProps={{
    textField: {
      size: "small",
      onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Delete" || event.key === "Backspace") {
          setToLRealDate(null);
        }
      },
    },
  }}
  label={"تا تاریخ"}
  value={toLRealDate || null}
  onChange={(newValue: any) => {
    setToLRealDate(newValue || null);
  }}
/>


                </FormControl>
              </Grid>

             <Grid item xs={12} mt={1}  >
               <Box px={1} columnGap={2} justifyContent={'center'} display={'flex'} flexDirection={'row-reverse'}  >
                 <Box >
                   <DyButton
                     caption={'ذخیره'}
                     color={'#00387C'}
                     onClick={() => { }}
                     disbled={!dirty || !isValid}
                     variant={'contained'}
                     bgColor={'#00387C'}
                     type={'submit'}
                   />
                 </Box>
 
                 <Box>
                   <DyButton
                     caption={'انصراف'}
                     disbled={false}
                     variant={'outlined'}
                     onClick={handleClose}
                   />
                 </Box>
               </Box>
             </Grid>
           </Grid>
         </Form>
     }
 
   </Formik>:
     <Box width={'100%'} py={6} textAlign={'center'}  >
     <Typography variant='body1' fontWeight={700} color={successAddUser?'green':'red'}   >{addUserMesaage}</Typography>
     <Button variant='outlined' color='info' sx={{my:2}}  onClick={()=>{
     }}  >
      تایید
     </Button>
    </Box>
    }
    </Grid>
     </Grid>
  )
}

export default EditStrategy